import { StateType } from '../../../../states';
import { selectGRBetsFromRound } from '../../selectors/round.selector';
import { GRRound } from '../../types/round';

type GRChipListSelectorProps = {
  roundId: GRRound;
};

const selectGRNbActiveBetsFromRound = (state: StateType, props: GRChipListSelectorProps) => {
  const bets = selectGRBetsFromRound(state, props);
  return bets.length ?? 0;
};

const selectGRChipListProps = (state: StateType, props: GRChipListSelectorProps) => {
  const nbActiveBets = selectGRNbActiveBetsFromRound(state, props);
  return {
    nbActiveBets,
  };
};

export default selectGRChipListProps;
